import {
  defaultStaffModuleAccess,
  resolveStaffModuleAccess,
} from './staffModulePermissions';

/** Legacy ID (WOW-796) — solo resuelve como mensual hasta migración */
export const LEGACY_REPOSITORIO_FLUJO_CAJA_MODULE_ID = 'repositorio_flujo_caja';

export const REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID = 'repositorio_flujo_caja_mensual';
export const REPOSITORIO_FLUJO_CAJA_QUINCENAL_MODULE_ID = 'repositorio_flujo_caja_quincenal';
export const REPOSITORIO_FLUJO_CAJA_SEMANAL_MODULE_ID = 'repositorio_flujo_caja_semanal';

export const REPOSITORIO_FLUJO_CAJA_MODULE_IDS = [
  REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID,
  REPOSITORIO_FLUJO_CAJA_QUINCENAL_MODULE_ID,
  REPOSITORIO_FLUJO_CAJA_SEMANAL_MODULE_ID,
];

export function isRepositorioFlujoCajaModuleId(moduleId) {
  return REPOSITORIO_FLUJO_CAJA_MODULE_IDS.includes(moduleId);
}

export function defaultRepositorioFlujoCajaAccess(roles) {
  return defaultStaffModuleAccess(roles);
}

function legacyIdsFor(moduleId) {
  return moduleId === REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID
    ? [LEGACY_REPOSITORIO_FLUJO_CAJA_MODULE_ID]
    : [];
}

function findPerm(permissions, moduleId, legacyModuleIds = []) {
  const list = Array.isArray(permissions) ? permissions : [];
  const direct = list.find((p) => p.moduleId === moduleId);
  if (direct?.hasAccess === true || direct?.hasAccess === false) return direct;
  for (const legacyId of legacyModuleIds) {
    const legacy = list.find((p) => p.moduleId === legacyId);
    if (legacy?.hasAccess === true || legacy?.hasAccess === false) return legacy;
  }
  return direct;
}

function isCompanyFlujoCajaGranted(moduleId, companyPerms) {
  if (companyPerms === undefined) return true;
  const companyPerm = findPerm(companyPerms, moduleId, legacyIdsFor(moduleId));
  return companyPerm?.hasAccess === true;
}

export function resolveRepositorioFlujoCajaAccess(
  moduleId,
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isRepositorioFlujoCajaModuleId(moduleId)) return false;
  if (!isCompanyFlujoCajaGranted(moduleId, companyPerms)) return false;
  return resolveStaffModuleAccess(
    moduleId,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
    legacyIdsFor(moduleId),
  );
}
